import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  data: {},
  error: {},
});

const { Types, Creators } = createActions({
  getRecentLists:              null,
  getRecentListsConnected:     ['stores'],
  getRecentListsError:         ['error'],
  getRecentListsDisconnected:  null,
});

export const getRecentListsReducer = ( state ) =>
  state.set('loading', true)

export const getRecentListsConnectedReducer = ( state, { stores } ) =>
  state.set('data', stores)
       .set('loading', false)
       .set('loaded', true)

export const getRecentListsDisconnectedReducer = ( state ) =>
  state.set('loading', false)

export const getRecentListsErrorReducer = ( state, { error } ) =>
  state.set('error', error)
       .set('loading', false)

export const recentListReducer = createReducer(INITIAL_STATE, {
  [Types.GET_RECENT_LISTS]:              getRecentListsReducer,
  [Types.GET_RECENT_LISTS_CONNECTED]:    getRecentListsConnectedReducer,
  [Types.GET_RECENT_LISTS_DISCONNECTED]: getRecentListsDisconnectedReducer,
  [Types.GET_RECENT_LISTS_ERROR]:        getRecentListsErrorReducer,
})


export const RecentListTypes = Types
export default Creators;


// WEBPACK FOOTER //
// ./src/reducers/recentListReducer.js